import { createContext, useContext, useState, type ReactNode } from "react";

const InfoContext = createContext<{
  shouldShowInfo: boolean;
  setShouldShowInfo: (value: boolean) => void;
  formDeadline?: Date;
  setFormDeadline: (value?: Date) => void;
  fromExpedient?: boolean;
  canBeCancelled: boolean;
  setCanBeCancelled: (value: boolean) => void;
  isCancelled?: boolean;
  setIsCancelled?: (value: boolean) => void;
}>({
  shouldShowInfo: false,
  setShouldShowInfo: () => {},
  formDeadline: undefined,
  setFormDeadline: () => {},
  canBeCancelled: false,
  setCanBeCancelled: () => {},
});

export const InfoProvider = ({ children }: { children: ReactNode }) => {
  const [shouldShowInfo, setShouldShowInfo] = useState(true);
  const [formDeadline, setFormDeadline] = useState<Date>();
  const [canBeCancelled, setCanBeCancelled] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);

  return (
    <InfoContext.Provider
      value={{
        shouldShowInfo,
        setShouldShowInfo,
        formDeadline,
        setFormDeadline,
        canBeCancelled,
        setCanBeCancelled,
        isCancelled,
        setIsCancelled,
      }}
    >
      {children}
    </InfoContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useInfo = () => {
  const context = useContext(InfoContext);
  if (context === undefined) {
    throw new Error("useInfo must be used within an InfoProvider");
  }
  return context;
};
